import React from 'react';
import { Calendar } from 'primereact/calendar';

interface MySalarySideBarProps {
  startDate: Date | null;
  endDate: Date | null;
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}

export const MySalarySideBar: React.FC<MySalarySideBarProps> = ({
  startDate,
  endDate,
  onDateRangeChange,
}) => {
  const handleStartDateChange = (date: Date | null) => {
    onDateRangeChange(date, endDate);
  };

  const handleEndDateChange = (date: Date | null) => {
    onDateRangeChange(startDate, date);
  };

  return (
    <div
      style={{
        width: '300px',
        padding: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        height: 'fit-content',
      }}
    >
      <div
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '20px',
          color: '#041E49',
        }}
      >
        סינון תאריכים
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: '500',
            color: '#374151',
          }}
        >
          תאריך התחלה
        </label>
        <Calendar
          value={startDate}
          onChange={(e) => handleStartDateChange(e.value as Date | null)}
          dateFormat="dd/mm/yy"
          placeholder="בחר תאריך התחלה"
          style={{ width: '100%' }}
          showIcon
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label
          style={{
            display: 'block',
            marginBottom: '8px',
            fontWeight: '500',
            color: '#374151',
          }}
        >
          תאריך סיום
        </label>
        <Calendar
          value={endDate}
          onChange={(e) => handleEndDateChange(e.value as Date | null)}
          dateFormat="dd/mm/yy"
          placeholder="בחר תאריך סיום"
          style={{ width: '100%' }}
          showIcon
        />
      </div>
    </div>
  );
};
